import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, filter, take } from 'rxjs/operators';
import { OffrollLopManagementService } from 'src/app/core/services/offroll-lop-management.service';
import { SidebarService } from 'src/app/core/services/sidebar.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { AlertDialogComponent } from './common-component/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ExportMonthYearDialogComponent } from './common-component/export-month-year-dialog/export-month-year-dialog.component';
import { PermissionService } from 'src/app/core/services/permission-service.service';
declare var bootstrap: any;

export interface Employees {
  emp_id: string;
  name: string;
  designation?: string;
  company?: string;
  department?: string;
  total_leaves_remaining?: any;
  doj?: string;
  remainder_day_flag?: boolean;
  sick_leave?: number;
  casual_leave?: number;
  earned_leave?: number;
  pay_adjustment?: PayAdjustment | null;

}

export interface PayAdjustment {
  id?: number;
  date?: string;
  loss_of_pay_days?: number;
  fixed_reimbursement?: any;
  reimbursement_amount?: any;
  deduction?: any;
  payable_days?: number;
  remarks?: string;
  is_disabled?: boolean;
  employee?: string;
  project?: any;
  project_code?: any;
  unlisted_project?: any;
  project_name?: any;
  created_at?: Date;
  updated_at?: Date;
}

export interface Filters {
  job_title: string;
  company__name__icontains: string;
  doj__gte: string | null; // Start date
  doj__lte: string | null;
}

export interface TempFilters {
  job_title: string;
  company__name__icontains: string;
  doj__gte: Date | null; // Start date
  doj__lte: Date | null;
}

export interface LeaveDetail {
  used?: number;
  maximum?: number;
  earned?: number;
  remaining?: number;
}

export interface TotalLeavesRemaining {
  [leaveType: string]: LeaveDetail;
}

@Component({
  selector: 'app-off-roll-leave-lop-management',
  templateUrl: './off-roll-leave-lop-management.component.html',
  styleUrls: ['./off-roll-leave-lop-management.component.css']
})
export class OffRollLeaveLopManagementComponent implements OnInit {
  @ViewChild('filterModalRef') filterModalRef!: ElementRef;
  searchText: string = '';
  searchTextChanged: Subject<string> = new Subject<string>();
  employees: Employees[] = [];
  selectedEmployees: Employees[];
  selectedIds = new Set<string>();
  doj: Date | null = null;
  showSidePopup = false;
  selectedEmployee: any = null;
  popupMode: 'single' | 'bulk' = 'single';
  employeedata: any;
  projectCodes: any[] = [];
  projectCode: number | null = null;
  entities: any[] = [];
  job_titles: any[] = [];
  alertType: 'success' | 'warning' | 'error' | 'info' = 'info';
  alertMessage: string = '';
  fixedreimburses: any;
  pageSize = 30;
  pageSizeOptions = [10, 20, 30, 40, 50];
  current_page = 1;
  total_pages = 1;
  offRoleManagerPermission: any;
  isManager: boolean = false;
  isHr: boolean = false;
  offRoleHrPermission: any;
  isFormDisabled: boolean = true;
  selectedRole: 'hr' | 'manager' | null = null;
  isSubmissionWindowOpen: boolean = false;
  remainderFlag: boolean = false;
  deadline: number = 23;
  decemberDeadline: number = 31;
  submissionStartDate: number = 20;
  sidebarCollapsed: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private employeeService: OffrollLopManagementService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private permissionService: PermissionService,
    private sidebarService: SidebarService
  ) {

  }


  onPageChanged(page: number) {
    this.current_page = page;
    this.updateQueryParams();
    this.fetchEmployees(page, this.pageSize);
  }

  onPageSizeChanged(size: number) {
    this.pageSize = size;
    this.current_page = 1;
    this.updateQueryParams();
    this.fetchEmployees(this.current_page, this.pageSize);
  }

  filters: Filters = {
    job_title: null,
    company__name__icontains: null,
    doj__gte: null,
    doj__lte: null,
  };

  tempFilters: TempFilters = {
    job_title: null,
    company__name__icontains: null,
    doj__gte: null,
    doj__lte: null,
  };


  ngOnInit(): void {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });

    this.searchTextChanged.pipe(debounceTime(1000)).subscribe(() => {
      this.fetchEmployees(1);
    });

    this.route.queryParams.subscribe(params => {
      this.filters = {
        job_title: params['job_title'] || null,
        company__name__icontains: params['company__name__icontains'] || null,
        doj__gte: params['doj__gte'] || null,
        doj__lte: params['doj__lte'] || null,
      };

      this.tempFilters = {
        job_title: this.filters.job_title,
        company__name__icontains: this.filters.company__name__icontains,
        doj__gte: this.parseDate(this.filters.doj__gte),
        doj__lte: this.parseDate(this.filters.doj__lte),
      };

      // console.log(this.tempFilters);

      this.current_page = params['page'] ? +params['page'] : 1;
      this.pageSize = params['page_size'] ? +params['page_size'] : 30;
    });

    if (!this.route.snapshot.queryParams['company__name__icontains']) {
      this.updateQueryParams();
    }

    // calling all helper function 
    this.getEntity();
    this.getDesignation();
    this.getFixedReimbursement();
    this.getPermission();

  }


  //get Permissions  for HR and Manager 
  getPermission() {
    this.permissionService.getEmployeePermissions()
      .pipe(
        filter(data => !!data),
        take(1)
      )
      .subscribe(empPerms => {
        if (!empPerms) return;

        this.isManager = !!empPerms.is_offroll_manager;
        this.isHr = !!empPerms.hr_offroll_permission;
        if (!this.selectedRole) {
          if (this.isManager && !this.isHr) {
            this.selectedRole = 'manager';   // manager only
          } else if (!this.isManager && this.isHr) {
            this.selectedRole = 'hr';        // hr only
          } else if (this.isManager && this.isHr) {
            this.selectedRole = 'hr';        // both true → default HR
          } else {
            this.router.navigate(['/unauth-message']);
            return; // fallback (no permission case)
          }
        }
        this.fetchEmployees(this.current_page, this.pageSize);
      });
  }

  //check is submission window open or not 
  updateFormAccess(remainderflag: boolean) {
    this.isSubmissionWindowOpen = remainderflag;
    this.isFormDisabled = !(
      this.selectedRole === 'manager' &&
      this.isSubmissionWindowOpen
    );
  }

  // RADIO BUTTON CHANGE
  onRoleChange() {
    this.current_page = 1;
    // update URL for filters & paging
    this.updateQueryParams();
    this.fetchEmployees(this.current_page, this.pageSize);
    this.closeSidePopup();
  }

  // PAYLOAD FOR API   return string Because Angular Will not remove string false values.
  getRolePayload() {
    return {
      isHr: this.selectedRole === 'hr' ? "true" : "false",
      isManager: this.selectedRole === 'manager' ? "true" : "false"
    };
  }

  // function to fetch designation in filter
  getDesignation() {
    this.employeeService.getDesignation().subscribe({
      next: (res: any) => {
        if (Array.isArray(res.data)) {
          this.job_titles = res.data;
          //console.log('designation loaded:', this.job_titles);
        }
      },
      error: (err) => console.error('Failed to fetch designation', err),
    });
  }

  // function to fetch entity  in filter 
  getEntity() {
    this.employeeService.getCompany().subscribe({
      next: (res: any) => {
        if (Array.isArray(res)) {
          this.entities = res;
          //console.log('entity loaded:', this.entities);
        }
      },
      error: (err) => console.error('Failed to fetch entity', err),
    });
  }



  // function to fetch fixed reimbursement in  sidepopup 
  getFixedReimbursement() {
    this.employeeService.getFixedReimbursement().subscribe({
      next: (res: any) => {
        if (Array.isArray(res.data)) {
          this.fixedreimburses = res.data;
        }
      },
      error: (err) => console.error('Failed to fetch entity', err),
    });
  }



  // Format Date into dd-MM-yyyy
  private formatDate(date: Date | null): string {
    //console.log(date)
    return date ? this.datePipe.transform(date, "yyyy-MM-dd") || null : null;
  }

  // Parse yyyy-MM-dd to Date
  private parseDate(dateStr: string | null): Date | null {
    //console.log(dateStr)
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split("-");
    return new Date(+year, +month - 1, +day);
  }

  // fetching all Employee details 
  fetchEmployees(page: number = 1, size: number = 30): void {
    this.current_page = page;
    this.pageSize = size;

    const roleFlags = this.getRolePayload();

    const params = {
      search: this.searchText || '',
      page: this.current_page,
      page_size: this.pageSize,
      ...this.filters,
      isHr: roleFlags.isHr,
      isManager: roleFlags.isManager
    };

    this.employeeService.getEmployees(params).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.closeSidePopup();
          this.employees = res.data || [];
          this.total_pages = res.total_pages || 1;
          this.current_page = res.current_page || page;
          this.remainderFlag = res.remainder_day_flag;
          this.closeFilterModal();
          this.updateFormAccess(this.remainderFlag);
          this.handleRemainderAlert();
        }
      },
      error: (err) => {
        console.error('Error fetching employees:', err);
        this.employees = [];
      },
    });
  }


  //when user type some text in search box 
  onSearchInputChanged(value: string): void {
    this.current_page = 1;
    this.searchText = value;
    this.searchTextChanged.next(value);
    this.updateQueryParams();
  }

  //clicked on apply filter button 
  applyFilters(): void {
    this.filters = {
      job_title: this.tempFilters.job_title,
      company__name__icontains: this.tempFilters.company__name__icontains,
      doj__gte: this.tempFilters.doj__gte
        ? this.formatDate(this.tempFilters.doj__gte)
        : null,
      doj__lte: this.tempFilters.doj__lte
        ? this.formatDate(this.tempFilters.doj__lte)
        : null
    };
    this.current_page = 1;  // reset current page 1
    this.updateQueryParams();
    this.fetchEmployees(this.current_page, this.pageSize);
    this.closeFilterModal();
  }


  //function to close filter modal
  closeFilterModal(): void {
    if (this.filterModalRef?.nativeElement) {
      const modalInstance = bootstrap.Modal.getInstance(this.filterModalRef.nativeElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  }

  // code to remove filter chip on clicking cross button 
  onRemoveFilter(key: string): void {
    this.filters[key] = '';
    this.tempFilters[key] = '';
    this.updateQueryParams();
    this.fetchEmployees(this.current_page, this.pageSize);
  }

  //code to remove all selected filter 
  clearFilters(): void {
    const hasActiveFilters = this.hasFilters;
    this.filters = {
      job_title: null,
      company__name__icontains: null,
      doj__gte: null,
      doj__lte: null,
    };
    this.tempFilters = {
      job_title: null,
      company__name__icontains: null,
      doj__gte: null,
      doj__lte: null,
    };

    this.current_page = 1;

    if (hasActiveFilters) {
      this.updateQueryParams();
      this.fetchEmployees(this.current_page, this.pageSize);
    } else {
      console.log('No active filters skipping API call.');
    }
  }

  // getting boolean value to check if is filter applied or not 
  get hasFilters(): boolean {
    if (!this.filters) return false;
    return Object.values(this.filters).some(
      (value) => value !== null && value !== undefined && value !== ''
    );
  }

  //function to update query param 
  updateQueryParams(): void {
    const queryParams: any = {
      page: this.current_page,
      page_size: this.pageSize,
      ...this.filters,

    };

    Object.keys(queryParams).forEach(key => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: '',
      replaceUrl: true
    });
  }





  //code for checkbox checked  and unchecked 
  toggleSelection(empId: string, event: any): void {

    if (this.showSidePopup && this.popupMode === 'single') {
      this.closeSidePopup();
    }

    if (event.target.checked) {
      this.selectedIds.add(empId);
    } else {
      this.selectedIds.delete(empId);
    }

    this.updateSelectedEmployees()
  }

  // helper function to slect all available checkboxes on single click 
  toggleAll(event: Event) {

    if (this.showSidePopup && this.popupMode === 'single') {
      this.closeSidePopup();
    }

    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      this.employees.forEach(emp => {
        if (!emp.pay_adjustment) {
          this.selectedIds.add(emp.emp_id);
        }
      });
    } else {
      this.selectedIds.clear();
    }

    this.updateSelectedEmployees();
  }

  // Check is all availabale are selected or not
  isAllChecked(): boolean {
    const selectable = this.employees.filter(emp => !emp.pay_adjustment);
    return selectable.length > 0 && selectable.every(emp => this.selectedIds.has(emp.emp_id));
  }

  //open side popup on row click when single employee clicked 
  openSidePopup(employee: any) {
    this.popupMode = 'single';
    this.selectedEmployee = JSON.parse(JSON.stringify(employee));

    // Clear all checkboxes when opening single employee popup
    this.selectedIds.clear();

    // Load projects with single submission parameters
    this.loadProjectsForSingleMode(employee);

    this.showSidePopup = true;
    //console.log('Single employee popup opened:', employee);
  }

  // Get selected IDs (for bulk submit)
  getSelectedIds(): string[] {
    return Array.from(this.selectedIds);
  }

  // to real-time synchronization of seelcted checkbox if popup already open 
  updateSelectedEmployees() {
    this.selectedEmployees = this.employees.filter(emp => this.selectedIds.has(emp.emp_id));
    //console.log(this.selectedEmployees);
    if (this.popupMode === 'bulk' && this.showSidePopup) {
      if (this.selectedEmployees.length === 0) {
        this.closeSidePopup();
      }
    }
  }


  // Reusable dialog helper
  openDialog(title: string, message: string, type: 'alert' | 'success' | 'error' | 'confirm'): void {
    this.dialog.open(AlertDialogComponent, {
      data: { title, message, type },
      width: '350px',
      panelClass: 'off-roll-alert-dialog-container'
    });
  }

  // open bulk submit popup when user click on submit all button 
  openBulkPopup() {
    this.updateSelectedEmployees();
    if (this.selectedEmployees.length === 0) {
      this.openDialog('No Employees Selected', 'Please select at least one employee!', 'alert');
      return;
    }

    // Check if all selected employees are from SAME COMPANY
    if (!this.areAllEmployeesFromSameCompany()) {
      this.openDialog(
        'Different Entity Detected',
        'Please select employees from the same entity only for bulk submission.',
        'alert'
      );
      return; // Stop here if validation fails 
    }

    const payload = {
      type: 'bulk',
      ids: this.getSelectedIds()
    };
    this.popupMode = 'bulk';
    this.selectedEmployee = null;

    this.loadProjectsForBulkMode();

    this.showSidePopup = true;
    //console.log('Bulk submit popup opened:', payload);
  }


  closeSidePopup() {
    this.showSidePopup = false;
    this.selectedEmployee = null;
  }

  // helper to reset all bulk selection 
  resetBulkSelection() {
    this.selectedIds.clear();
    this.selectedEmployees = [];
  }

  //Helper function for project loading and validation

  private areAllEmployeesFromSameCompany(): boolean {
    if (this.selectedEmployees.length === 0) return false;

    // Get company of first employee (this becomes the reference)
    const firstCompany = this.selectedEmployees[0]?.company;

    // Check if all other employees have the exact same company
    // Even if firstCompany is undefined/null, all must match that value
    return this.selectedEmployees.every(emp => emp?.company === firstCompany);
  }


  //SINGLE MODE: Load projects with single submission parameters
  private loadProjectsForSingleMode(employee: any): void {
    const params = {
      type: 'single',
      email: employee?.email || '',
      company_name: employee?.company || null
    };
    this.getProjectCodesWithParams(params);
  }

  // Load projects with bulk submission parameters
  private loadProjectsForBulkMode(): void {
    const params = {
      type: 'bulk',
      email: '',  // Not applicable for bulk
      company_name: this.getSelectedCompanyName()  // Mandatory and Must be same for all selected employees
    };

    this.getProjectCodesWithParams(params);
  }


  //Company name of first selected employee (since all are same company) or empty string
  private getSelectedCompanyName(): string {
    if (this.selectedEmployees.length > 0) {
      return this.selectedEmployees[0]?.company || '';
    }
    return '';
  }

  // Fetch project codes based on provided parameters
  private getProjectCodesWithParams(params: any): void {
    this.employeeService.getProjectCodeWithParams(params).subscribe({
      next: (res: any) => {
        if (res?.success && Array.isArray(res.data)) {
          this.projectCodes = res.data.map((proj: any) => ({
            id: proj.id,
            displayName: `${proj.amplus_id} (${proj.name})`
          }));
          console.log('Projects loaded successfully');
        } else {
          console.warn('No projects found or invalid response');
          this.projectCodes = [];
        }
      },
      error: (err) => {
        console.error('Failed to fetch project codes with params:', err);
        this.projectCodes = [];
      },
    });
  }

  //final submit 
  handleSubmit(payload: any) {
    //console.log('Payload received from popup:', payload);

    // Open confirmation dialog
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '400px',
      panelClass: 'off-roll-alert-dialog-container',
      data: {
        title: 'Confirm Submission',
        message: 'Are you sure you want to submit the details?',
        type: 'confirm',
        confirmText: 'Submit',
        cancelText: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {

      if (!result) {
        console.log('Submission cancelled');
        return;
      }

      // User confirmed
      const type = payload?.type;
      console.log(`Confirmed submission for type: ${type}`);

      if (type === 'bulk') {
        //  BULK SUBMIT 
        this.employeeService.SubmitBulkEmployee(payload).subscribe({
          next: (res: any) => {
            if (res?.success) {
              console.log(' Bulk submission successful', res);
              //resetting all selected ids for bulk submittion 
              this.resetBulkSelection();
              this.showSidePopup = false;
              this.fetchEmployees(this.current_page, this.pageSize);
              this.closeSidePopup();
              this.openDialog('Success', res.message, 'success');
            } else {
              this.openDialog('Error', res.message || 'Failed to Submit bulk Details', 'error');
            }
          },
          error: (err) => {
            const errorMsg = 'Failed to Submit bulk Details'
            this.openDialog('Error', errorMsg, 'error');
          }
        });
      }

      else if (type === 'single') {
        const adjId = payload?.id

        if (adjId && adjId > 0) {
          //  UPDATE existing pay adjustment (PUT)
          this.employeeService.updatePayAdjustment(payload).subscribe({
            next: (res: any) => {
              if (res?.success) {
                console.log('Single employee update successful', res);
                this.resetBulkSelection();
                this.fetchEmployees(this.current_page, this.pageSize);
                this.showSidePopup = false;
                this.closeSidePopup();
                this.openDialog('Success', res.message, 'success');
              } else {

                this.openDialog('Error', res.message || 'Failed to update employee details', 'error');
              }

            },
            error: (err) => {
              const errorMsg = 'Failed to update employee details'
              this.openDialog('Error', errorMsg, 'error');
            }
          });
        } else {
          // CREATE new pay adjustment (POST)
          this.employeeService.createPayAdjustment(payload).subscribe({
            next: (res: any) => {
              if (res?.success) {
                console.log(' Single employee created successfully', res);
                this.openDialog('Success', res.message, 'success');
                this.resetBulkSelection();
                this.fetchEmployees(this.current_page, this.pageSize);
                this.showSidePopup = false;
                this.closeSidePopup();
              } else {
                this.openDialog('Error', res.message || 'Failed to submit employee details', 'error');
              }
            },
            error: (err) => {
              const errorMsg = 'Failed to submit employee details'
              this.openDialog('Error', errorMsg, 'error');
            }
          });
        }
      }
    });
  }

  // helper function to get total leaves...
  getTotalLeaves(emp: Employees): number {
    const totalLeaves = emp.total_leaves_remaining;

    if (!Array.isArray(totalLeaves) || totalLeaves.length === 0) {
      return 0;
    }

    let total = 0;
    const excludeKeys = ["Optional Leave"];

    for (const category of totalLeaves) {

      if (!category || typeof category !== 'object') continue;

      for (const [leaveType, leaveInfo] of Object.entries(category)) {

        if (excludeKeys.includes(leaveType)) continue;

        if (leaveInfo && typeof leaveInfo === 'object' && 'remaining' in leaveInfo) {
          const remaining = Number((leaveInfo as LeaveDetail).remaining ?? 0);
          if (!isNaN(remaining)) {
            total += remaining;
          }
        }
      }
    }
    return total;
  }


  //remainder alert function 
  showRemainderAlert(type: 'success' | 'warning' | 'error' | 'info', message: string) {
    this.alertType = type;
    this.alertMessage = message;
  }

  // find remaining days 
  getRemainingDays(): number {
    const today = new Date().getDate();
    const currentMonth = new Date().getMonth();
    const effectiveDeadline = currentMonth === 11 ? this.decemberDeadline : this.deadline;
    return (effectiveDeadline - today) + 1;
  }

  // helper function to find date month with suffix 

  formatDayMonthWithSuffix(day: number | null | undefined, monthOffset: number = 0): string {

    if (day === null || day === undefined || isNaN(day)) {
      return "";
    }

    if (day < 1 || day > 31) {
      return "";
    }

    const date = new Date();
    date.setDate(1); // Set to 1st of current month first
    date.setMonth(date.getMonth() + monthOffset);
    date.setDate(day); // Then set the desired day
    const dayNum = date.getDate();
    const monthName = date.toLocaleString('en-US', { month: 'short' });

    // Day suffix rules
    let suffix = "th";
    if (dayNum % 10 === 1 && dayNum !== 11) suffix = "st";
    else if (dayNum % 10 === 2 && dayNum !== 12) suffix = "nd";
    else if (dayNum % 10 === 3 && dayNum !== 13) suffix = "rd";

    return `${dayNum}${suffix} ${monthName}`;
  }


  //Handles remainder alert based on flag 
  handleRemainderAlert(): void {
    const remainingDays = this.getRemainingDays();
    const currentMonth = new Date().getMonth();
    const isDecember = currentMonth === 11;
    const effectiveDeadline = isDecember ? this.decemberDeadline : this.deadline;
    if (this.isSubmissionWindowOpen) {
      if (remainingDays > 1) {
        this.showRemainderAlert(
          'error',
          isDecember
            ? `<strong class="text-bold">${remainingDays} days left!</strong> 
             <strong>${this.formatDayMonthWithSuffix(effectiveDeadline)}</strong> is the last date. 
             Please submit your entries before that.`
            : `<strong class="text-bold">${remainingDays} days left!</strong> Please submit your entries.
             <strong>After ${this.formatDayMonthWithSuffix(effectiveDeadline)}</strong>, submissions will be closed and the table will reset automatically.`
        );
      } else if (remainingDays === 1) {
        this.showRemainderAlert(
          'error',
          `Today is <strong class="text-bold"> the last day! </strong> Please submit your entries before 
           <strong> the day ends.</strong> After today,submissions will be closed and the table will reset automatically.`
        );
      }
      else if (remainingDays <= 0) {
        this.showRemainderAlert(
          'error',
          `<strong class="text-bold">Submission closed!</strong> 
          The deadline has passed. The table will reset for next month.`
        );
      }
    } else {
      if (remainingDays <= 0) {
        this.showRemainderAlert(
          'error',
          isDecember
            ? `Submission closed! The submission window will open next year from 
       <strong class="text-bold">${this.formatDayMonthWithSuffix(this.submissionStartDate, 1)} to ${this.formatDayMonthWithSuffix(effectiveDeadline, 1)}</strong>.
       <strong class="text-bold">After ${this.formatDayMonthWithSuffix(effectiveDeadline, 1)} ,</strong> submissions will be closed and the table will reset automatically.`
            :
            `Submission closed! The submission window will open next month from 
       <strong class="text-bold">${this.formatDayMonthWithSuffix(this.submissionStartDate, 1)} to ${this.formatDayMonthWithSuffix(effectiveDeadline, 1)}</strong>.
       <strong class="text-bold">After ${this.formatDayMonthWithSuffix(effectiveDeadline, 1)} ,</strong> submissions will be closed and the table will reset automatically.`
        );
      } else {

        this.showRemainderAlert(
          'warning',
          isDecember
            ? `The submission window will open from
       <strong class="text-bold">${this.formatDayMonthWithSuffix(this.submissionStartDate)} to ${this.formatDayMonthWithSuffix(effectiveDeadline)}</strong>.
       Please ensure entries are submitted within this period.`
            :
            `The submission window will open from
       <strong class="text-bold">${this.formatDayMonthWithSuffix(this.submissionStartDate)} to ${this.formatDayMonthWithSuffix(effectiveDeadline)}</strong>.
       <strong class="text-bold">After ${this.formatDayMonthWithSuffix(effectiveDeadline)} ,</strong> submissions will be closed and the table will reset automatically.`
        );
      }

    }
  }


  // helper function to Format Date into dd-MM-yyyy 
  private formatDateWithTime(date: any): string {
    // Handle empty, null, undefined, or invalid values
    if (!date || date === 'null' || date === 'undefined') return '';

    try {
      const localDate = new Date(date);

      // Validate if the date object is valid
      if (isNaN(localDate.getTime())) {
        console.log('Invalid date value passed:', date);
        return '';
      }

      // Format for Indian Standard Time (Asia/Kolkata)
      const options: Intl.DateTimeFormatOptions = {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      };

      return new Intl.DateTimeFormat('en-IN', options).format(localDate);
    } catch (e) {
      console.error('Date formatting error:', e);
      return '';
    }
  }


  //function to export excel 
  exportToExcel(): void {
    const dialogRef = this.dialog.open(ExportMonthYearDialogComponent, {
      width: '350px',
      panelClass: 'export-dialog-container',

    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      const { month, year } = result;
      const formattedDate = `${year}-${String(month).padStart(2, '0')}-01`;
      //console.log(formattedDate);
      const { isHr, isManager } = this.getRolePayload();
      const exportParams = {
        export_month: formattedDate,
        isHr,
        isManager
      };
      this.employeeService.exportAllEmployees(exportParams).subscribe({
        next: (res) => {
          if (!res?.success || !Array.isArray(res.data) || res.data.length === 0) {
            this.openDialog('Oops!', 'No employees details found to export.', 'alert');
            return;
          }

          const employees = res.data;
          const headers = [
            'Temp Code',
            'Name',
            'Entity',
            'Designation',
            'Department',
            'Date of Joining',
            'Earned Leave Taken',
            'Sick Leave Taken',
            'Casual Leave Taken',
            'Total Available Leave',
            'Project Code(Project Name)',
            'Unlisted Project Code and Name',
            'Pay Adjustment Date',
            'Created At',
            'Updated At',
            'Loss of Pay Days',
            'Fixed Reimbursement',
            'Deduction',
            'Payable Days',
            'Remarks'
          ];

          const rows = employees.map(emp => {
            const payAdj = emp.pay_adjustment || {};

            const projectcode = payAdj?.project_code ?? '';
            const projectname = payAdj?.project_name ?? '';

            return [
              emp.emp_id || '',
              emp.name || '',
              emp.company || '',
              emp.designation || '',
              emp.department || '',
              emp.doj ? new Date(emp.doj).toLocaleDateString() : '-',
              emp.earned_leave ?? 0,
              emp.sick_leave ?? 0,
              emp.casual_leave ?? 0,
              this.getTotalLeaves(emp) || 0,
              projectcode && projectname ? `${projectcode} (${projectname})` : projectcode || projectname || '',
              payAdj.unlisted_project ?? '',
              payAdj.date || '',
              this.formatDateWithTime(payAdj.created_at),
              this.formatDateWithTime(payAdj.updated_at),
              payAdj.loss_of_pay_days ?? 0,
              payAdj.reimbursement_amount ?? 0,
              payAdj.deduction ?? 0,
              payAdj.payable_days ?? 0,
              payAdj.remarks ?? ''
            ]
          });

          const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees');
          const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
          const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
          saveAs(blob, `employees_${formattedDate}.xlsx`);

          this.openDialog('Success', `Employees details exported successfully for ${month}/${year}. (${employees.length} records)`, 'success');
        },
        error: (err) => {
          console.error('Error exporting employees:', err);
          this.openDialog('Error', 'Failed to export employees details . Please try again later.', 'error');
        }
      });
    });
  }
}




